import React from 'react';
import { connect } from 'react-redux';
import ProductTypeTwo from '../../../features/product/product-type-two';
import ProductTypeCatalog from '../../../features/product/product-type-catalog';
import ProductCardSkeleton from '../../../features/product/product-card-skeleton';

//Import Utils
import { shopFilterProducts } from '../../../../utils';

function GridProduct(props) {
  const { displayCount, curPage, cols = 4, productType = "", isLoading } = props;
  let subClass = getClass(cols);
  let products = props.products;
  products = shopFilterProducts(products, props.filter);

  function getClass(cols) {
    let subClass = "";
    if (cols === 3) {
      subClass = "col-xl-4";
    } else if (cols === 4) {
      subClass = "col-xl-3";
    } else if (cols === 5) {
      subClass = "col-xl-5col";
    } else if (cols === 6) {
      subClass = "col-xl-2";
    } else if (cols === 7) {
      subClass = "col-xl-7col";
    } else if (cols === 8) {
      subClass = "col-xl-8col";
    }
    return subClass;
  }

  if (isLoading) {
    return (
      <div className={`product-group row row-sm position-relative ${props.type === "list" ? "product-intro list-style" : ""}`}>
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((index) => (
          <div key={"skel-grid-" + index} className={`col-6 col-md-3 pt-3 ${subClass}`}>
            <ProductCardSkeleton count={1} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`product-group ${productType === "flex-grid" && props.type === "grid" ? "row product-intro divide-line up-effect" : ("row row-sm position-relative " + (props.type === "list" ? "product-intro list-style" : ""))} `}>
      {
          props.type === "grid" ?
            products.slice((curPage - 1) * displayCount, curPage * displayCount).map((product, index) => (
              productType === "flex-grid" ?
                <React.Fragment key={"flex-grid" + index}>
                  <div className="skel-pro skel-pro-grid col-6 col-sm-4 col-lg-3"></div>

                  <ProductTypeCatalog
                    addClass="inner-quickview inner-icon flex-product col-6 col-sm-4 col-lg-3"
                    type="flex-layout"
                    isAction={false}
                    product={product}
                  />
                </React.Fragment>
                :
                <React.Fragment key={"grid" + index}>
                  <div className={`skel-pro skel-pro-grid col-6 col-md-3 ${subClass}`}></div>

                  <ProductTypeCatalog
                    addClass={`inner-quickview inner-icon col-6 col-md-3 pt-3 ${subClass}`}
                    product={product}
                    noAction={cols > 4 ? true : false}
                  />
                </React.Fragment>
            ))
            :
            products.slice((curPage - 1) * displayCount, curPage * displayCount).map((product, index) => (
              <React.Fragment key={"list" + index}>
                <div className="skel-pro skel-pro-list"></div>

                <ProductTypeTwo
                  addClass="col-6 col-sm-12 pt-3 pb-3 left-details product-list"
                  product={product}
                />
              </React.Fragment>
            ))
      }
      {
        products.length === 0 ?
          <h4 className="mt-3 ml-4 text-dark mb-4" style={{ fontWeight: 400 }}><i className="fas fa-info-circle text-primary mr-2"></i>Nie znaleziono produktów pasujących do Twojego wyboru.</h4>
          : ""
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    filter: state.filter ? state.filter : [],
    // products: state.data.products ? state.data.products : ''
  };
};

export default connect(mapStateToProps)(GridProduct);
